/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Mcp_Connect_Signed_In_AsInputs */

const en_mcp_connect_signed_in_as = /** @type {(inputs: Mcp_Connect_Signed_In_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Signed in as ${i?.email}`)
};

const es_mcp_connect_signed_in_as = /** @type {(inputs: Mcp_Connect_Signed_In_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesión iniciada como ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Signed in as {email}" |
*
* @param {Mcp_Connect_Signed_In_AsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_signed_in_as = /** @type {((inputs: Mcp_Connect_Signed_In_AsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Signed_In_AsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_signed_in_as(inputs)
	return en_mcp_connect_signed_in_as(inputs)
});